import RestApi from "./../../../api/rest-api-client";
const srvcEndpoint = "/change_logs";
export default {
	search: 					async (req, opts) 			=> 		RestApi.request("GET", 		srvcEndpoint, req, opts),
	get: 							async (id, req, opts) 	=> 		RestApi.request("GET", 		srvcEndpoint, id, req, opts),
	update:  					async (id, data, opts) 	=> 		RestApi.request("PUT", 		srvcEndpoint, id, data, opts),
	acknowledge: 			async (req, opts) 			=> 		RestApi.request("POST", 	srvcEndpoint, req, {endpoint: `/change_logs/acknowledge`}),
};
